import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { brokerApi, BrokerOnboarding } from 'api/broker';
import { useAuth } from 'providers';

export const BROKER_ONBOARDING_QUERY_KEY = 'broker-onboarding';

export const useBrokerOnboarding = (): UseQueryResult<BrokerOnboarding> => {
  const { isSignedIn, isLoaded } = useAuth();
  const enabled = isSignedIn && isLoaded;

  return useQuery([BROKER_ONBOARDING_QUERY_KEY], brokerApi.getOnboarding, { enabled, refetchOnWindowFocus: false });
};
